import TechFooter from './Footer/TechFooter';
import TechHeader from './Header/TechHeader';

import styles from '../css/App.module.css';

const Layout = ({ children, fullWidth = false }) => {
  return (
    <div>
      <div className={styles.appContainer}><TechHeader /></div>
      <div className={!fullWidth && styles.appContainer}>{children}</div>
      <div className={styles.appContainer}><TechFooter /></div>
    </div>
  )
}

export default Layout;